<div class="modal-header" *ngIf="idea">
  <button
    type="button"
    (click)="dismiss()"
    class="btn-close"
    title="Close"></button>
  <h3 class="modal-title">Idea was moved to following destinations:</h3>
</div>

<div class="modal-body idea-modal clearfix">
  <a
    *ngFor="let move of idea.moves"
    class="move-details"
    routerLink="/topics/{{ move.session_id }}"
    [queryParams]="{ idea: move.idea_id }"
    (click)="close()">
    <div class="session-image">
      <img
        alt
        [src]="
          move.session_thumbnail || 'image/default_session_thumbnail.png'
            | assets
        " />
    </div>
    <div class="session-title">
      {{ move.session_title }}
      <div class="date">moved on {{ moveDate(move) }}</div>
    </div>
  </a>
</div>
